export default "__VITE_ASSET__BpJ6zIT___"